/*jslint node: true*/
"use strict";

var ko = require("pli/knockout");
var pli = require("pli/forms");
var pliObservable = require("pli/forms-knockoutcontrols");

var dataCache = require("../datacache");
var entityRegistry = require("../entity-registry");
var picklistItemExtensions = require("../picklist-common/picklistItemViewModelExtensions");


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ContactViewModel
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------

function ContactViewModel(form) {
    this.initPicklistItem("Geo-Contact-", form);

    this.code = this.id = pliObservable(null, null, "required");
    this.isCompany = ko.observable(false);
    this.isLessor = ko.observable(false);
    this.fullName = pliObservable();
    this.gst = pliObservable();
    this.energyLinkPartner = pliObservable();
    this.phone = pliObservable();
    this.mobile = pliObservable();
    this.fax = pliObservable();
    this.email = pliObservable();
    this.accountingCode = pliObservable();
    this.bankFee = pliObservable(null, "C2", "numeric");
    this.withholdingPercentage = pliObservable(null, pli.config.editorPrecisionPercentFormat, "numeric");
    this.currency = pliObservable(null, dataCache.getObservable("currency"), "picklist");
    this.depositorySameAsMailing = ko.observable(false);
    this.isOwner = ko.observable(false);
    this.useInNetCalcs = ko.observable(false);
    this.qbytePartner = pliObservable();
    this.mailingAddress = {
        guid: ko.observable(),
        address: pliObservable(),
        attention: pliObservable()
    };

    this.depositoryAddress = {
        guid: ko.observable(),
        address: pliObservable(),
        attention: pliObservable()
    };

    this.savedAddress = "";
    this.savedAttention = "";

    //this.depositoryAddress.attentionComputed = ko.computed()

    this.updateDepositoryFromCheckbox = function () {
        if (this.depositorySameAsMailing()) {
            this.savedAddress = this.depositoryAddress.address();
            this.savedAttention = this.depositoryAddress.attention();
            this.depositoryAddress.address(this.mailingAddress.address());
            this.depositoryAddress.attention(this.mailingAddress.attention());
        } else {
            this.depositoryAddress.address(this.savedAddress);
            this.depositoryAddress.attention(this.savedAttention);
            this.savedAddress = "";
            this.savedAttention = "";
        }
        return true;
    };

    this.extras.displayName = ko.computed(ContactViewModel.prototype._computeDisplayName, this);
    this.useSaveDialog = true;
}


//-------------------------------------------
ContactViewModel.prototype.fromCacheItem = function contactFromCacheItem(item) {
    var record;
    if (item && item.length) { // Handle array item (existing contact)
        record = {
            guid: item[item.length - 1],
            code: item[0],
            isLessor: (item[1] === "LESSOR" || item[1] === "BOTH"),
            isCompany: (item[1] === "COMPANY" || item[1] === "BOTH"),
            fullName: item[2],
            phone: item[3],
            fax: item[4],
            isOwner: item[5],
            useInNetCalcs: item[6]
        };
        this.extras.state("loading");
    } else if (item && item.guid) { // Handle object item (existing contact)
        record = item;
        this.extras.state("loading");
    } else { // Handle new contact
        record = null;
    }

    return record;
};


//-------------------------------------------
ContactViewModel.prototype.load = function loadContact(record) {
    record = record || {};

    this.code.reset();
    this.fullName.reset();
    this.gst.reset();
    this.energyLinkPartner.reset();
    this.phone.reset();
    this.mobile.reset();
    this.fax.reset();
    this.email.reset();
    this.accountingCode.reset();
    this.bankFee.reset();
    this.withholdingPercentage.reset();
    this.currency.reset();
    this.mailingAddress.attention.reset();
    this.depositoryAddress.attention.reset();
    this.qbytePartner.reset();

    this.guid(record.guid || null);
    this.code.load(record.code);
    this.isCompany(!!record.isCompany);
    this.isLessor(!!record.isLessor);
    this.fullName.load(record.fullName);
    this.gst.load(record.gst);
    this.energyLinkPartner.load(record.energyLinkPartner);
    this.phone.load(record.phone);
    this.mobile.load(record.mobile);
    this.fax.load(record.fax);
    this.email.load(record.email);
    this.accountingCode.load(record.accountingCode);
    this.bankFee.load(record.bankFee);
    this.withholdingPercentage.load(record.withholdingPercentage);
    this.currency.load(record.currency === "CAN" ? "CDN" : record.currency);
    this.depositorySameAsMailing(!!record.depositorySameAsMailing);
    this.mailingAddress.address.load(record.mailingAddress && record.mailingAddress.address);
    this.mailingAddress.attention.load(record.mailingAddress && record.mailingAddress.attention);
    this.isOwner(!!record.isOwner);
    this.useInNetCalcs(!!record.useInNetCalcs);
    this.qbytePartner.load(record.qbytePartner);
    if (this.depositorySameAsMailing()) {
        this.savedAddress = "";
        this.savedAttention = "";
        this.depositoryAddress.address.load(this.mailingAddress.address());
        this.depositoryAddress.attention.load(this.mailingAddress.attention());
    } else {
        this.depositoryAddress.address.load(record.depositoryAddress && record.depositoryAddress.address);
        this.depositoryAddress.attention.load(record.depositoryAddress && record.depositoryAddress.attention);
    }
};


//-------------------------------------------
ContactViewModel.prototype._computeDisplayName = function computeContactDisplayName() {
    var code = this.code();
    return (code ? "Contact ".concat(code) : "(No contact code yet)");
};


//-------------------------------------------
ContactViewModel.prototype.acquire = function acquire() {
    pli.forms.registry.contactAcquireForm.viewModel.open(this.id());
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Initialization
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
var contactForm = pli.forms.registry.contactForm;

if (typeof contactForm !== "object") { throw new Error("Contact form element could not be found - did you render it using CreateContactForm?"); }
if (contactForm.viewModel) { throw new Error("Contact form has already been initialized"); }

ko.utils.extend(ContactViewModel.prototype, picklistItemExtensions.mixins);
contactForm.viewModel = new ContactViewModel(contactForm);

entityRegistry.contact.open.create = entityRegistry.contact.open.edit = contactForm.viewModel.open;
entityRegistry.contact.getPicklistBehaviourData = function getPicklistBehaviourData() {
    return {
        onNewItem: contactForm.viewModel.open,
        onOpenItem: contactForm.viewModel.open,
        picklistData: dataCache.getObservable("contact")
    };
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
module.exports = ContactViewModel;



//////////////////
// WEBPACK FOOTER
// ./app/picklist-contact/contactViewModel.js
// module id = 568
// module chunks = 49